/* SHOPYTHON reviews — drag-and-drift strip.

   This used to be a CSS transform marquee. It looked right but could not be
   grabbed, and reviews are meant to be read at the reader's pace. So the track
   is a real horizontally scrollable element now: touch swipe, trackpad and
   shift-wheel come free from the browser, and this file adds mouse dragging and
   the slow drift on top.

   The snippet renders the list THREE times and we park the reader in the middle
   copy. Two copies would be enough to loop forwards, but scrollLeft cannot go
   below zero, so dragging backwards would hit a wall — with a third copy there
   is a full list of runway in both directions and the wrap is invisible.

   The loop distance is measured from the DOM rather than assumed, so it survives
   any card count, width or gap change.

   Drift stops while the pointer is over the strip, while it holds keyboard
   focus, and while the reader is dragging. requestAnimationFrame does not run in
   a background tab, so it stops there too without asking. */
(function () {
  "use strict";
  if (window.__sfRevs) return;
  window.__sfRevs = true;

  var vp = document.querySelector('.revs-vp');
  var track = vp && vp.querySelector('.revs');
  if (!vp || !track) return;

  var REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SPEED = 38;            // px per second, matching the marquee it replaced
  var loop = 0;              // width of one copy of the list, including its trailing gap
  var ready = false;

  function measure() {
    var cards = track.querySelectorAll('.rev');
    var third = Math.round(cards.length / 3);
    if (!third || !cards[third]) return 0;
    return cards[third].offsetLeft - cards[0].offsetLeft;
  }

  /* Keep the reader inside the middle copy, so there is always a whole list to
     drag through in either direction. */
  function wrap() {
    if (!ready || !loop) return;
    if (vp.scrollLeft >= loop * 2) vp.scrollLeft -= loop;
    else if (vp.scrollLeft < loop) vp.scrollLeft += loop;
  }

  var hovering = false, dragging = false, last = 0;
  /* Browsers keep scrollLeft in whole (device) pixels, so a sub-pixel step is
     rounded away: 38 px/s is only 0.32 px a frame on a 120 Hz screen and the
     strip never moved. Bank the fraction and move only whole pixels. */
  var carry = 0;

  function tick(now) {
    if (!last) last = now;
    var dt = (now - last) / 1000;
    last = now;
    if (ready && !hovering && !dragging && dt < 0.25) {
      carry += SPEED * dt;
      var step = Math.floor(carry);
      if (step) {
        vp.scrollLeft += step;
        carry -= step;
        wrap();
      }
    }
    requestAnimationFrame(tick);
  }

  /* ---- mouse dragging. Touch scrolls natively, so leave it alone. ---- */
  var startX = 0, startScroll = 0, moved = 0, pressing = false;
  var SLOP = 4;   // px of travel before a press counts as a drag rather than a click

  vp.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'touch' || e.button !== 0) return;
    pressing = true; dragging = false; moved = 0;
    startX = e.clientX;
    startScroll = vp.scrollLeft;
    /* Deliberately NOT capturing the pointer here. A capture on the container
       retargets the compatibility mouse events to it, so the click lands on
       .revs-vp instead of on the product link inside the card and the link
       never navigates. Capture is taken below, once this is really a drag. */
  });

  vp.addEventListener('pointermove', function (e) {
    if (!pressing) return;
    var dx = e.clientX - startX;
    moved = Math.max(moved, Math.abs(dx));
    if (!dragging) {
      if (moved <= SLOP) return;      // still a click; leave the link alone
      dragging = true;
      vp.classList.add('dragging');
      try { vp.setPointerCapture(e.pointerId); } catch (err) {}
    }
    var target = startScroll - dx;
    /* Shift the anchor along with the wrap, or the next move of the same drag
       would snap back to wherever the pointer went down. */
    while (target < loop) { target += loop; startScroll += loop; }
    while (target >= loop * 2) { target -= loop; startScroll -= loop; }
    vp.scrollLeft = target;
    e.preventDefault();
  });

  function endDrag(e) {
    if (!pressing) return;
    pressing = false; dragging = false;
    vp.classList.remove('dragging');
    if (e && e.pointerId != null && vp.hasPointerCapture(e.pointerId)) vp.releasePointerCapture(e.pointerId);
  }
  vp.addEventListener('pointerup', endDrag);
  vp.addEventListener('pointercancel', endDrag);
  vp.addEventListener('lostpointercapture', endDrag);

  /* A drag that finishes on a link must not also follow it. */
  vp.addEventListener('click', function (e) {
    if (moved > SLOP) { e.preventDefault(); e.stopPropagation(); }
    moved = 0;
  }, true);

  vp.addEventListener('mouseenter', function () { hovering = true; });
  vp.addEventListener('mouseleave', function () { hovering = false; });
  vp.addEventListener('focusin', function () { hovering = true; });
  vp.addEventListener('focusout', function () { hovering = false; });
  vp.addEventListener('scroll', wrap, { passive: true });

  addEventListener('resize', function () {
    var l = measure();
    if (l) { loop = l; wrap(); }
  });

  function start() {
    loop = measure();
    if (!loop) return;
    vp.scrollLeft = loop;          // park in the middle copy before anything can wrap
    ready = true;
    if (!REDUCED) requestAnimationFrame(tick);
  }
  // card height depends on the images, and the loop distance is read from layout
  if (document.readyState === 'complete') start();
  else addEventListener('load', start);
})();
